import {
  SIGNUP_INVITE_ONLY_ERROR_CODE,
  SIGNUP_INVITE_ONLY_MESSAGE,
} from '@zaikoo/core/applications/auth/signupGate';

export function getAuthErrorMessage(code?: string): string {
  switch (code) {
    case 'CredentialsSignin':
      return 'Invalid email or password. Please try again.';
    case 'EmailNotVerified':
      return 'Please verify your email address before signing in.';
    case 'AccountNotLinked':
      return 'This account is associated with a different sign-in method.';
    case 'forbidden':
      return 'You do not have permission to access this resource.';
    case SIGNUP_INVITE_ONLY_ERROR_CODE:
      return `${SIGNUP_INVITE_ONLY_MESSAGE} Contact us to request access.`;
    default:
      return code ? 'An error occurred during sign in. Please try again.' : '';
  }
}
